import React from 'react';
import { EmptyInspireOptions, InspireOptions } from '../Types';
import DataState from '../Types/DataState';

export const getInitialState = (): State => ({
  isAuthenticating: true,
  inspireOptions: {
    state: DataState.LOADING,
    data: EmptyInspireOptions,
  },
});

export interface ContextType {
  state: State;
  dispatch: React.Dispatch<{}>;
}

export interface State {
  isAuthenticating: boolean;
  inspireOptions: {
    state: string;
    data: InspireOptions;
  };
}

function reducer(state: State, action: any): State {
  const { type, payload } = action;
  switch (type) {
    case 'SET_INSPIRE_OPTIONS': {
      return { ...state, inspireOptions: payload };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
